import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import { Redirect } from 'react-router-dom';
import * as S from './styles';
import { format} from 'date-fns';

// COMPONENTES---------
import { ListaItemLS } from '../ListarPesquisas/ListaItemLS';
import { Add_ItensLS } from './Add_ItensLS';
import { ListaItemBD } from '../ListarPesquisas/listaItemBD';
import { PesquisaPadrao } from '../../componentes/Pesquisas/PesquisaPadrao';
import { SetFunctions } from '../../componentes/Functions';

// Filtro API---------
import { Api_Produtos } from '../../services/FiltrosApi/produtos_api';

//----------------------------------------------------
export function AddOrcamento(props) {
    const { state, dispatch } = useContext(Context);
    const { evento, orcamento } = state.evento;
    const { listaPesquisa, playmodal} = state.parametros;
    const {inforProduto, inforCaixa } = state.produtos;
    const { logado } = state.cliente;

    const [somaTotalLS, setSomaTotalLS] = useState('');
    const [clickNovoItem, setClickNovoItem] = useState(false);
    const [clickNovoTipo, setClickNovoTipo] = useState(false);
    const [displayItem, setdisplayItem] = useState(false);

    //--------------------------------

    const { PesquisarTipoTodos, PesquisarTipoProd } = Api_Produtos();
    const { SetListaPesquisa } = SetFunctions();
    const dataAtual = format(new Date(), 'yyyy-MM-dd');

    //--------------------------------
    const setOcamento = (key, value) => {
        dispatch({
            type: 'set_Orcamento',
            payload: { ...orcamento, [key]: value }
        })
    };

    // ------------------------
    async function AddItemTipo(){
        await api.post('/Produtos/addItemTipo', {   
            userCadastro: logado.idLogado,
            tipo: orcamento.novoTipo,
            item: orcamento.nomeItem,
        })
        .then(res => {
            if(res.data.errors){
                alert("ERRO: Algo Errado!")

            }else{
                alert("Sucesso!!!");
                setClickNovoTipo(false);
                setClickNovoItem(false);
                PesquisarTipoProd(orcamento.novoTipo);
            };  
        })
    };

    // ------------------------
    async function AddItem(){
        if(listaPesquisa.listaTipoEvento.length > 0){
            setClickNovoItem(false);
            dispatch({
                type: 'set_Orcamento',
                payload: {
                    ...orcamento,
                    selectItem: orcamento.nomeItem
                }
            });

            if(listaPesquisa.novoItem.length >= 3){
                await api.post(`/Produtos/atualizar/item/${inforProduto.id_Produto}`, {   
                    item:orcamento.nomeItem,
                })
                .then(res => {
                    if(res.data.errors){
                        alert("ERRO: Algo Errado!")

                    }else{
                        alert("Sucesso!!!");
                        dispatch({
                            type: 'set_Orcamento',
                            payload: {
                                ...orcamento,
                                selectItem: ""
                            }
                        });
                    };  
                })
            }else{
                alert("Não pode ter menos que 3 letras!")
            }
        } else{
            AddItemTipo()
        }
    };

    //-----------------------------------
    function Add_LS() {
        const newDespesa = {
            data: orcamento.data,
            nomeItem: orcamento.selectItem,
            valor: orcamento.valorItem,
            tipo: orcamento?.tipo || orcamento?.novoTipo,
            codigo: orcamento.selectItem + Math.floor(Math.random() * 1000)
        };

        if (orcamento.data && orcamento.selectItem && orcamento.valorItem && (orcamento.tipo || orcamento.novoTipo)) {
            const placaLS = localStorage.getItem(evento.placa);

            if (placaLS) {
                if (JSON.parse(placaLS).length > 0) {
                    const arrayStory = JSON.parse(placaLS);
                    arrayStory.push(newDespesa);
                    localStorage.setItem(evento.placa, JSON.stringify(arrayStory));
                } else {
                    localStorage.setItem(evento.placa, JSON.stringify([newDespesa]));
                }
            } else {
                localStorage.setItem(evento.placa, JSON.stringify([newDespesa]));
            };

            dispatch({
                type: 'set_Orcamento',
                payload: {
                    ...orcamento,
                    selectItem: "",
                    nomeItem:"",
                    valorItem:"",
                    codigoAtualiza: orcamento.nomeItem + Math.floor(Math.random() * 1000),
                }
            });

        } else {
            alert("Preencha todos os campos")
        }
    };

    //--------------------
    async function FinalizarOrcamento() {
        const arrayDesp = [];
        listaPesquisa.listaItemLS.map(e => {
            const depLS = {
                data: e.data,
                tipo: e.tipo,
                nomeItem: e.nomeItem,
                valor: e.valor,
            }
            arrayDesp.push(depLS)
        });
        if (arrayDesp.length > 0) {
            await api.put(`/evento/atualizar/pagamento/${evento.id_Evento}`,
                arrayDesp
            )
                .then(res => {
                    if (res.data.errors) {
                        alert("ERRO: Preencha todos os campos corretamente!")
                    } else {
                        alert("Sucesso!!!");
                        localStorage.removeItem(evento.placa);

                        dispatch({
                            type: 'set_Orcamento',
                            payload: {
                                ...orcamento,
                                data: "",
                                tipo: "",
                                nomeItem:"",
                                valorItem:"",
                                codigoAtualiza: Math.floor(Math.random() * 1000),
                            }
                        });

                        setfiltroItem([]);

                        dispatch({
                            type: 'set_ListaPesquisa',
                            payload: {
                                ...listaPesquisa,
                                novoItem: "",
                                listaItemLS: [],
                            }
                        });

                        dispatch({
                            type: 'SET_PLAYMODAL',
                            payload: {
                                ...playmodal,
                                playModalOrcamento: false,
                                playModalDetalhesEven: true,
                            }
                        });
                    }
                })
        } else { alert("erro") }
    };

    //----------------------------------------
    function BotaoNovoBarraPesquisa() {
        setClickNovoItem(true);
        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                novoItem: orcamento.nomeItem,
            }
        });
    };

    const [filtroItem, setfiltroItem] = useState([])


    //--------Filtrar ao digitar----------------
    function FiltrarItem(nome) {
        let item = [];
        item = listaPesquisa.listaItemProd.filter(obj => nome ? obj.toLowerCase().includes(nome.toLowerCase()) : '');
        setfiltroItem(item);

        dispatch({
            type: 'set_Orcamento',
            payload: {
                ...orcamento,
                nomeItem: nome ? nome : '',
            }
        });

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                novoItem: item.length === 0 ? nome : "",
            }
        });
    };

    //---------------------------------------
    useEffect(() => {
        FiltrarItem(listaPesquisa.nomeItem);

    }, [listaPesquisa.nomeItem]);

    //---------------------------------------
    function EditarSelect() {
        dispatch({
            type: 'set_Orcamento',
            payload: {
                ...orcamento,
                selectItem: "",
                nomeItem:"",
                valorItem:"",
            }
        });
    };

    //---------------------------------------
    useEffect(() => {
        // Soma Total Despesa--
        const somaX = listaPesquisa.listaItemLS.map(e => e.valor);
        if (somaX.length > 0) {
            let somaTotal = 0;
            for (let i = 0; i < somaX.length; i++) {
                somaTotal += somaX[i];
            }
            setSomaTotalLS(somaTotal);
        };
    }, [listaPesquisa.listaItemLS])

    // ---------------------------------------
    useEffect(() => {
        if (orcamento.tipo) {
            PesquisarTipoProd(orcamento.tipo);

            if (orcamento.tipo === 'outro') {
                setfiltroItem([]);
                SetListaPesquisa("listaItemProd", []);
                setClickNovoTipo(true);
                setdisplayItem(false);
            }else{
                setdisplayItem(true);
            }; 
        };
    }, [orcamento.tipo]);

    // -------------------------------------------
    function addTipo() {
        setClickNovoTipo(false);
        setClickNovoItem(true)
        setdisplayItem(true)
        
        dispatch({
            type: 'set_Orcamento',
            payload: {
                ...orcamento,
                tipo: "",
                selectItem: "",
                nomeItem:"",
                valorItem:"",
            }
        });

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                listaTipoEvento: [],
                listaItemProd: [],
                novoTipo:"",
                novoItem:""
            }
        });
    };

    // --------------------------------
    useEffect(() => {
        PesquisarTipoTodos();
    }, [evento.placa, orcamento.codigoAtualiza, inforCaixa.nomeItem, inforCaixa.selectItemDespesa, inforCaixa.novoItemDespesa])


    // -------------------------------
    function fechar(){
        setClickNovoTipo(false);
        dispatch({
            type: 'set_Orcamento',
            payload: {
                ...orcamento,
                tipo: "",
                novoTipo: ""
            }
        });

    };

    // ##########################################################################
    return (
        <S.bodyModal modalBloque={true}>
            <S.divLancamento>
                {!logado.conectado && <Redirect to='/' />}
                <span style={{ 'display': "flex", 'color': 'white', 'justifyContent': "center" }}>
                    ORÇAMENTO
                </span>

                <div className='flexCaixa'>
                    <div style={{ "display": "flex", 'flexDirection': "column", 'flex': '1' }}>
                        <span> Data:</span>
                        <div style={{ display: 'flex' }}>
                            <input
                                style={{ backgroundColor: "#30353F" }}
                                type="date"
                                value={orcamento.data}
                                onChange={(e) => setOcamento("data", e.target.value)}
                                max={dataAtual}
                            />
                        </div>
                    </div>

                    <div style={{ 'display': "flex", flexDirection: 'column', 'flex': '1' }}>
                        <span>{clickNovoTipo ? "Novo Tipo" : "Tipo"}</span>

                        {!clickNovoTipo ?
                        <select
                        style={{ display:"flex" }}
                        value={orcamento.tipo}
                        onChange={e => setOcamento('tipo', e.target.value)}
                        >
                            <option> {orcamento.novoTipo ? orcamento.novoTipo : orcamento.tipo? orcamento.tipo : ""} </option>

                            {listaPesquisa.listaTipoEvento.map((t, k) =>
                                <option key={k}>{t}</option>
                            )}
                            <option
                                value="outro"
                                style={{ 'color': "black", 'fontWeight': "600" }}
                            >
                                outro
                            </option>
                        </select>

                        :

                        <div style={{ display:"flex" }}>
                            <input
                                style={{ "backgroundColor": "#30353f", "border": "1px solid #00c7ff" }}
                                placeholder='minimo 3 letras'
                                autoFocus
                                type='text'
                                value={orcamento.novoTipo}
                                onChange={(e) => setOcamento("novoTipo", e.target.value)}
                            />

                            {orcamento.novoTipo.length >= 3 ?
                                <button
                                    className='bottonAdd'
                                    onClick={() => addTipo()}
                                >
                                    add
                                </button>
                                :
                                <button
                                    className='bottonAdd'
                                    style={{ "backgroundColor": "red", "color": "white" }}
                                    onClick={() => fechar()}
                                >
                                    X
                                </button>
                            }
                        </div>
                        }
                    </div>
                </div>

                {/*---------------------------*/}
                {displayItem &&
                <>
                {
                (!orcamento.selectItem && orcamento.tipo  ) ?
                    <>
                    <S.divPesq>
                        <PesquisaPadrao
                            refNomeCPF={true}
                            titulo="Item"
                            placeholder="item"
                            nomeBotao=""
                            Pesquisar={false}
                            PesqDentroModal={false}
                            Lupa={false}
                            playModal_Add={false}
                            playBotao={false}
                        />
                    </S.divPesq>

                    {orcamento.nomeItem &&
                    <div style={{ display: "flex" }}>
                        <S.divListaBD>
                            <ListaItemBD
                            Cadastro={true}
                                listaItem={filtroItem}
                                refItemOcamento = {true}
                            />
                        </S.divListaBD>
                    </div>
                    }
                    </>

                    :

                    <Add_ItensLS
                    AddItem = {AddItem}
                    itemSelect = {orcamento.selectItem}
                    valorItem = {orcamento.valorItem}
                    nomeItem = {orcamento.nomeItem}
                    setClickNovoItem={setClickNovoItem}
                    clickNovoItem={clickNovoItem}
                    EditarSelect={EditarSelect}
                    Adicionar={Add_LS}
                    setdisplayItem = {setdisplayItem}
                    setItem = {setOcamento}
                    /> 
                    }
                </>}

                {/* ----------- */}
                <div className='tagLista'>
                    <ListaItemLS
                        nomeLS={props.nomeLS}
                        setInfor={SetListaPesquisa}
                        listaItemLS={listaPesquisa.listaItemLS}
                    />
                </div>
            </S.divLancamento>

            <S.Finalizar>
                <div style={{ "display": 'flex', "margin": "10px 0", }}>
                    <span>
                        Total Pagamentos:
                        {" " + somaTotalLS.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </span>
                </div>
                <div className='divFinal'>
                    <button
                        style={{ "margin": "10px 0", 'color': "black" }}
                        onClick={() => FinalizarOrcamento()}>
                        Finalizar
                    </button>
                </div>
            </S.Finalizar>
        </S.bodyModal>
    )
}